import { alpha } from "@mui/material/styles";

// Estilos do modal "Analisar padrão" (análise de 30 dias de um equipamento,
// aberto pela detecção de falha recorrente dos Alertas inteligentes).
// Segue o visual dos blocos da Central de Alertas: cabeçalho com título
// `mySubtitle` + caption e MetricInfo à direita, cards de indicador no mesmo
// esqueleto dos KPIs (quadrado do ícone + rótulo + valor, borda e fundo em
// alpha da cor semântica) e destaque no formato dos itens dos Alertas
// inteligentes. Cores sempre via cores.js / theme — nunca hex fixo.
const styles = (theme) => {
	const escuro = theme.palette.mode === "dark";
	const corDestaque = escuro
		? theme.palette.colors.purple.medium
		: theme.palette.colors.purple.dark;

	return {
		// Drawer à direita (tela cheia no mobile), cabeçalho fixo e corpo rolável.
		painelDrawer: {
			width: { xs: "100%", md: "600px" },
			display: "flex",
			flexDirection: "column",
			backgroundImage: "none",
		},
		linhaCabecalho: {
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "space-between",
			gap: 1,
			p: "24px 24px 12px",
		},
		acoesCabecalho: {
			display: "flex",
			alignItems: "center",
			gap: 0.5,
		},
		botaoFechar: {
			width: "32px",
			height: "32px",
			borderRadius: "8px",
			border: `1px solid ${theme.palette.divider}`,
		},
		sobretitulo: {
			color: corDestaque,
			fontWeight: 600,
			textTransform: "uppercase",
			letterSpacing: "0.06em",
		},
		nomeEquipamento: {
			fontSize: "1.2rem",
			fontWeight: 600,
			color: theme.palette.text.primary,
			lineHeight: 1.3,
			wordBreak: "break-word",
		},
		corpoDrawer: {
			flexGrow: 1,
			overflowY: "auto",
			p: "8px 24px 24px",
		},
		titulo: {
			display: "flex",
			flexDirection: "column",
			minWidth: 0,
		},
		subtitulo: {
			color: theme.palette.text.secondary,
			textTransform: "uppercase",
			letterSpacing: "0.04em",
			fontVariantNumeric: "tabular-nums",
		},
		conteudo: {
			display: "flex",
			flexDirection: "column",
			gap: 2,
		},
		tituloSecao: {
			fontSize: "0.82rem",
			fontWeight: 600,
			color: theme.palette.text.primary,
			mb: 1,
		},
		// 5 indicadores numa linha (2 colunas no mobile).
		linhaIndicadores: {
			display: "grid",
			gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(5, minmax(0, 1fr))" },
			gap: 1,
		},
		indicador: {
			minWidth: 0,
			p: "12px",
			borderRadius: "10px",
			display: "flex",
			flexDirection: "column",
			gap: "4px",
			backgroundColor: theme.palette.action.hover,
		},
		valorIndicador: (cor) => ({
			color: cor,
			fontSize: "1.05rem",
			fontWeight: 700,
			lineHeight: 1.2,
			fontVariantNumeric: "tabular-nums",
		}),
		rotuloIndicador: {
			color: theme.palette.text.secondary,
			fontSize: "0.7rem",
			lineHeight: 1.2,
		},
		// Insight da faixa de horário em destaque na cor da recorrência.
		observacao: {
			p: "12px 14px",
			borderRadius: "10px",
			border: `1px solid ${alpha(corDestaque, escuro ? 0.35 : 0.3)}`,
			backgroundColor: alpha(corDestaque, escuro ? 0.1 : 0.06),
			color: theme.palette.text.primary,
			fontSize: "0.82rem",
		},
		areaGrafico: {
			height: "130px",
		},
		tooltipGrafico: {
			backgroundColor: theme.palette.background.paper,
			border: `1px solid ${theme.palette.divider}`,
			borderRadius: "8px",
			fontSize: "0.75rem",
		},
		// Cursor do hover do gráfico: realce sutil derivado do tema no lugar
		// do retângulo cinza chapado padrão do recharts (feio no dark).
		cursorGrafico: {
			fill: alpha(theme.palette.text.primary, 0.08),
		},
		// Linha da lista: severidade, alerta, início, duração, ciclo.
		linhaAlerta: {
			display: "grid",
			gridTemplateColumns: "10px minmax(0, 1fr) 84px 70px 90px",
			alignItems: "center",
			gap: 1.5,
			py: "9px",
			borderTop: `1px solid ${theme.palette.divider}`,
		},
		pontoSeveridade: (cor) => ({
			width: "8px",
			height: "8px",
			borderRadius: "50%",
			backgroundColor: cor,
		}),
		linhaTituloAlerta: {
			display: "flex",
			alignItems: "center",
			gap: "6px",
			minWidth: 0,
		},
		tituloAlertaTabela: {
			fontSize: "0.78rem",
			color: theme.palette.text.primary,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
		textoNumero: (cor) => ({
			fontSize: "0.75rem",
			color: cor || theme.palette.text.secondary,
			fontWeight: cor ? 600 : 400,
			fontVariantNumeric: "tabular-nums",
			whiteSpace: "nowrap",
		}),
		barraCiclo: {
			display: "flex",
			gap: "2px",
		},
		segmentoCiclo: (cor) => ({
			flex: 1,
			height: "5px",
			borderRadius: "2px",
			backgroundColor: cor || theme.palette.divider,
		}),
		estadoVazio: {
			py: 4,
			textAlign: "center",
		},
		skeletonIndicador: {
			height: "60px",
			borderRadius: "10px",
		},
		// Mesma altura do ResponsiveContainer do gráfico.
		skeletonGrafico: {
			height: "150px",
			borderRadius: "10px",
		},
		skeletonTabela: {
			display: "flex",
			flexDirection: "column",
			gap: 1,
		},
		skeletonLinha: {
			height: "34px",
			borderRadius: "8px",
		},
	};
};

export default styles;
